/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// @mui
import {
    Card,
    Typography,
    Dialog,
    Box,
    Switch,
    Paper,
    Button,
    Popper,
    TablePagination,
    MenuList,
    MenuItem,
    Grow,
    DialogTitle,
    DialogActions,
    Tooltip,
    FormControl,
    Select,
    InputLabel,
    ClickAwayListener,
    useTheme,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { alpha } from '@mui/material/styles';
// components
import { useForm } from 'react-hook-form';
import { FormProvider } from 'src/components/hook-form';
import MultiAssigneesDropdown from 'src/components/Dropdowns/SelectMultiAssignees';
import { treatmentBoxStyle } from 'src/styles/NewLead';
import { getJourneyLabel, getJourneyDot } from 'src/utils/leadJourney';
import Activities from './Activities';
import { FollowUp, AppointmentPage } from '../lead';
import { ReusableSidebar } from '../calendar';
import { Iconify, Label } from '../../../components';
import { NotFound } from '../../../components/empty-content';
import { UnableToContact } from '../../../components/failedToAttendTabs';
import { AssignTaskPopup, AddReminderPopup, EditPersonalDetailsPopup, AppointmentAssignTaskPopup, ArchivedLeadPopUp } from '../../../components/dialogPopUp';
import {
    OpenAttendedPopup,
    OpenUnAttendedPopup,
    OpenConsultationPopup,
    OpenContactLeadPopup
} from '../../../components/fullScreenPopUps';
// general
import {
    AttendedAppointment,
    MessageAndReminder,
    PaymentOption,
    PersonalDetails,
    TreatmentAndAppointment
} from '../general/app';
// redux
import { setCurrentTreatmentDataGlobal } from '../../../redux/slices/multiTreatment';
import {
    getLeadReminderData,
    followUpSlice,
    getAppointment,
    tableLead,
    clearLead,
    updateSteps,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    updateFollowUpLead,
    CompleteTreatment,
    updateReminder,
    getLeadNotes,
    setAssigned,
    addLeadTaskTab,
    leadTaskListCounter,
    updateLeadTaskCounter,
    setLeadDetailTaskPageFilter,
    deleteReminderData,
    taskCompletedUser,
    setAction,
    taskUnassignedUser,
    ArchivedLeadDashBoard
} from '../../../redux/slices/lead';
import { getPracticeItem } from '../../../redux/slices/practice';
import { clearPracticeUserData } from '../../../redux/slices/practiceUser';
import { getActivities } from '../../../redux/slices/activity';
import { useSelector, dispatch } from '../../../redux/store';
import { setLoader } from '../../../redux/slices/loader';
// constants
import { CreateLeadHeaderData, TASK_TAB_HEAD } from '../../../constants/LeadDetailConst';
// hooks
import {
    useTable,
    useTabs,
    useResponsive,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useReminderToggle,
    useArchivedToggle,
    useAssignTaskToggle,
    useToggle,
    useAuth,
    useConsultationAttendToggle,
} from '../../../hooks';
// utils
import { getIconAndColor, getPriorityColor } from '../../../utils/taskPriority';
import capitalizeFirstLetter from '../../../utils/capitalizedFunc';
import { setRowLeadData } from '../../../utils/getRowLeadData';
import { localStorageRemoveItem } from '../../../utils/storage-available';
// style
import { common } from '../../../theme/palette';
import {
    taskCard,
    taskButton,
    plusMenu,
    plusButton,
    plusMenuIcon,
    completeTreatmentCancel,
    completeTreatmentConfirm,
    taskListCardStyle,
} from '../../../styles/leadTaskReminder';
import { yesBtnStyleForLoader } from '../../../styles/Common';
// §9 MUST FE — V2 Lead Tasks list + flag hook for the V2 short-circuit
import LeadTaskList from '../../tasks/LeadTaskList';
import TaskErrorBoundary from '../../../components/TaskErrorBoundary';
import useFeaturePermission from '../../../hooks/useFeaturePermission';

const LeadDetailTasksV1 = ({ reminder, leadDetail, reloadTaskCounter, handleLoading }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const leadId = useParams();
    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const reminderDataId = useRef();
    const isLight = theme.palette.mode === 'light';
    const { user } = useAuth();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const isDesktop = useResponsive('down', 'sm');

    const { practiceUser } = useSelector((state) => state.practiceUser);
    const { activityList } = useSelector((state) => state.activity);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const [anchorElAssign, setAnchorElAssign] = useState(null);

    const {
        isAppointmentBooked, attendance,
        contactLead, BookingAttendance,
        markAsComplete, followUpLead,
        isAssigned, leadTaskTab,
        taskLeadCounter,
        leadDetailTaskPageFilter,
        taskDetail,
        isTasksCompleted,
        action,
        unassignedUser
    } = useSelector((state) => state.lead);

    const { isLoader } = useSelector((state) => state.loaderReducer);

    const { currentTab, onChangeTab, setCurrentTab } = useTabs(leadTaskTab);

    const [validStep, setValidStep] = useState(false);
    const [assignedUser, setAssignedUser] = useState(isAssigned);
    const [tasksCompletedUser, setTasksCompletedUser] = useState(isTasksCompleted);
    const [Lead, setLead] = useState(0);
    const [userID, setUserID] = useState('');
    const [open, setOpen] = useState(false);
    const [markComplete, setMarkComplete] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [anchorEl] = useState(null);
    const [reminderList, setReminderList] = useState([]);
    const [addPopupType, setAddPopupType] = useState('editTask');
    const [leadData, setLeadData] = useState('');
    const [assigneeData] = useState([]);
    const [reminderData, setReminderID] = useState(0);
    const [openSidebar, setOpenSidebar] = useState(false);
    const [additionalTabState, setAdditionalTabState] = useState('Today');
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const [assignees, setAssignees] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedAssigneeFilter, setSelectedAssigneeFilter] = useState([]);
    const [reloadCounters, setReloadCounters] = useState(null);

    const leadTreatment = leadDetail?.lead_treatments[0];
    const addTaskHide = leadTreatment?.status !== undefined && leadTreatment?.status !== 'CLOSED';

    const { onChangeTab: onAdditionalTab } = useTabs(additionalTabState);
    const { currentTreatmentDataGlobal } = useSelector((state) => state.multiTreatment);

    const {
        page,
        rowsPerPage,
        onChangePage,
        onChangeRowsPerPage,
        setPage,
        setRowsPerPage
    } = useTable();

    const assigneeDataFilter = [];
    selectedAssigneeFilter.forEach(els => assigneeDataFilter.push(els.id));

    const defaultValues = { multiSelectAssignee: assigneeDataFilter || [] };
    const methods = useForm({ defaultValues });
    const { setValue, handleSubmit } = methods;

    const onSubmit = (data) => { setValidStep(!!data); };

    // --- Effects ---

    useEffect(() => {
        if (practiceId) {
            dispatch(getPracticeItem(practiceId));
        }
    }, [practiceId]);

    useEffect(() => {
        if (reloadCounters) {
            sidebarCloser();
            reloadTaskCounter({ userId: assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '', id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser });
        }
    }, [reloadCounters]);

    useEffect(() => {
        if (selectedAssigneeFilter && selectedAssigneeFilter.length > 0) {
            setSelectedValue('All');
        }
    }, [selectedAssigneeFilter]);

    useEffect(() => {
        if (!isEmpty(currentTreatmentDataGlobal)) {
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (action) {
            dispatch(setAction(null));
        }
    }, []);

    useEffect(() => {
        setAdditionalTabState(leadDetailTaskPageFilter);
    }, []);

    useEffect(() => () => cleanUp(), []);

    // Reset filter/pagination state on mount.
    // Do NOT re-fetch here — the parent (LeadDetailView) already provides
    // leadReminder via the `reminder` prop, and useLayoutEffect syncs it
    // into reminderList. Re-fetching with the 'Today' date filter would
    // overwrite unfiltered data from the parent and hide future tasks.
    useEffect(() => {
        setCurrentTab('');
        dispatch(setLeadDetailTaskPageFilter('Today'));
        onAdditionalTab('', 'Today');
        setAdditionalTabState('Today');
        dispatch(taskCompletedUser(false));
        dispatch(taskUnassignedUser(false));
        dispatch(setAssigned(false));
        setPage(0);
        setRowsPerPage(10);
    }, []);

    useLayoutEffect(() => {
        if (!reminder) {
            setReminderList([]);
        }
        if (reminder && reminder?.results) {
            setReminderList(reminder?.results);
        }
    }, [reminder]);

    useEffect(() => {
        if (taskDetail) {
            setLeadData(taskDetail);
        }
    }, [taskDetail]);

    useEffect(() => {
        if (leadData && leadData?.lead?.id) {
            dispatch(getLeadNotes(leadData?.lead?.id, practiceId));
        }
    }, [leadData]);

    useEffect(() => {
        if (isAssigned || !isAssigned) {
            setAssignedUser(isAssigned);
        }
    }, [isAssigned]);

    useEffect(() => {
        if (isTasksCompleted || !isTasksCompleted) {
            setTasksCompletedUser(isTasksCompleted);
        }
    }, [isTasksCompleted]);

    useEffect(() => {
        if (assignedUser) {
            setSelectedValue('My tasks');
        } else if (unassignedUser) {
            setSelectedValue('Unassigned tasks');
        } else {
            setSelectedValue('All');
        }
    }, [assignedUser, unassignedUser]);

    const cleanUp = () => {
        // Reset local table data on unmount — no shared Redux table data
        setReminderList([]);
    };

    // --- Handlers ---

    const handleClose = (status, archive) => {
        dispatch(setLoader(false));
        setOpenSidebar(false);
        if (archive === true) {
            navigate('/dashboard/app');
        }
        if (status?.toLowerCase?.() === 'finish') {
            const data = { is_completed: true };
            dispatch(updateReminder(data, reminderDataId.current, practiceId, handleReminder, 'markComplete'));
            setConfirmation(false);
        }
        setTimeout(() => {
            const htmlElement = document.querySelector('body');
            htmlElement.classList.remove('overflow-hidden');
        }, 200);
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseContacts();
        onCloseReminder();
        setLead(null);
    };

    const STEPS = [
        { label: 'Contact', component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} /> }
    ];
    const [leadStep, setLeadStep] = useState(STEPS);

    const handleChangePage = (event, newPage) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', rowsPerPage, rowsPerPage * newPage, (currentTab == null || currentTab === 'All') ? '' : currentTab, leadId.id, assignees, '', '', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
        onChangePage(event, newPage);
    };

    const handleChangePerPage = (event) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', event.target.value, 0, (currentTab == null || currentTab === 'All') ? '' : currentTab, leadId.id, assignees, '', '', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
        onChangeRowsPerPage(event);
    };

    const handleFilterTask = (event, newValue) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, newValue === 'All' ? '' : newValue, leadId.id, assignees, '', '', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
        onChangeTab(event, newValue);
        onChangeRowsPerPage({ target: { value: 10 } });
        dispatch(addLeadTaskTab(newValue));
        reloadTaskCounter({ userId: assignees, id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser });
    };

    const handleAttendFailedClick = (id, reminderItem, lead) => {
        localStorageRemoveItem('localTreatmentData');
        if (reminderItem && reminderItem.id && reminderItem?.lead_treatment?.lead) {
            setRowLead(setRowLeadData(reminderItem, leadData));
        }
        if (id && reminderItem) {
            leadDataHandler(reminderItem);
            dispatch(followUpSlice(id, practiceId));
            setTimeout(() => { dispatch(getAppointment(practiceId, id)); }, 300);
        } else {
            dispatch(followUpSlice(lead || Lead, practiceId));
            setTimeout(() => { dispatch(getAppointment(practiceId, lead || Lead)); }, 300);
        }
        dispatch(updateFollowUpLead('UnAttended'));
        setTimeout(() => { onOpenUnRecordAttend(); }, 800);
    };

    const handleReminderPopup = (notes, data) => {
        setLead(leadDetail?.id);
        if (data) setLeadData(data);
        setAddPopupType(notes);
        onOpenReminder();
    };

    const handleAttendClick = (lead, data) => {
        leadDataHandler(data.id);
        dispatch(updateFollowUpLead('Attended'));
        dispatch(followUpSlice((lead || Lead), practiceId));
        dispatch(setCurrentTreatmentDataGlobal({
            lead_id: leadDetail?.id || '',
            first_name: leadDetail?.first_name || '',
            last_name: leadDetail?.last_name || '',
            treatmentData: data?.lead_treatment
        }));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, (lead || Lead)));
            onOpenRecordAttend(lead || Lead);
        }, 800);
    };

    const buttonHandleClose = (event) => {
        if (anchorEl.current && anchorEl.current.contains(event.target)) return;
        setOpen(false);
    };

    useEffect(() => {
        if (practiceUser && practiceUser.results) {
            const userData = practiceUser?.results.filter((el) => el?.user?.id === user?.pk);
            if (userData.length > 0) setUserID(userData[0]?.user?.id);
        }
    }, [practiceUser]);

    useEffect(() => {
        if (contactLead) {
            setLeadStep([{ label: 'Contact', component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} /> }]);
        } else {
            setLeadStep([{ label: 'Contact', component: <Activities activityList={activityList.results} notAllow /> }]);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            steps.push({
                label: isAppointmentBooked === 'Booking Details' ? 'Booking outcome' : isAppointmentBooked === 'Unable to contact' ? 'Unable to Contact' : 'Booking outcome',
                component: isAppointmentBooked === 'Booking Details'
                    ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                    : isAppointmentBooked === 'Unable to contact'
                        ? <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                        : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
            });
            setLeadStep(steps);
            return;
        }
        setLeadStep(STEPS);
    }, [BookingAttendance]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            if (attendance === 'attendance') {
                steps.push({
                    label: 'Booking outcome',
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                        : isAppointmentBooked === 'Unable to contact'
                            ? <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({ label: 'Appointment Outcome', component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview /> });
            } else {
                steps.push({
                    label: 'Booking outcome',
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} />
                        : isAppointmentBooked === 'Unable to contact'
                            ? <UnableToContact ref={inputRef} handleNext={onSubmit} completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({ label: 'Patient Detail', component: <PersonalDetails ref={inputRef} handleNext={onSubmit} /> });
                steps.push({ label: 'Payment options', component: <PaymentOption ref={inputRef} handleNext={onSubmit} /> });
                steps.push({ label: 'Message review & reminders', component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'CreatLead'} /> });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance]);

    useEffect(() => {
        if (markAsComplete && followUpLead === 'contact') {
            dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
        }
        if (markAsComplete && followUpLead === 'consultation') {
            dispatch(ConsultationAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'Attended') {
            dispatch(RecordAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'UnAttended') {
            dispatch(recordUnAttended(handleClose));
        }
        if (markAsComplete && followUpLead === 'archivedLead') {
            dispatch(ArchivedLeadDashBoard(handleClose));
            onCloseArchiveLead();
        }
    }, [markAsComplete, followUpLead]);

    const handleReminder = (value) => {
        const assignees = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        if (value === 'markComplete') {
            dispatch(updateLeadTaskCounter([]));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, leadId.id, assignees, '', 'leadNotes', 'counter', additionalTabState, isTasksCompleted, false, '', unassignedUser));
            dispatch(leadTaskListCounter(practiceId, 'LeadDetail', leadDetail?.lead_treatments[0]?.status, leadDetail?.id));
            dispatch(leadTaskListCounter(practiceId, 'LeadDetail', 'TODO', leadDetail?.id));
            dispatch(leadTaskListCounter(practiceId, 'LeadDetail', '', leadDetail?.id));
            dispatch(followUpSlice(leadId.id, practiceId, 'LeadDetail'));
            return;
        }
        dispatch(followUpSlice(leadId.id, practiceId, 'LeadDetail'));
        dispatch(getLeadNotes(leadId.id, practiceId, handleSuccess));
        dispatch(getActivities(practiceId, leadId.id, 10, 0));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
        dispatch(updateLeadTaskCounter([]));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, leadId.id, assignees, '', '', 'counter', additionalTabState, isTasksCompleted, false, '', unassignedUser));
        reloadTaskCounter({ userId: assignees, id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser });
    };

    // Callback for TaskSidebar to reload only lead detail context
    const onTaskUpdate = () => {
        handleReminder('markComplete');
    };

    const handleSuccess = (data) => {
        if (data.message === 'Task completed !') {
            setMarkComplete(false);
            const key = enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                autoHideDuration: 5000,
                action:
                    <>
                        <Button onClick={() => undoReminder()} variant='success' size="small" sx={{ color: '#00AB55', '&:hover': { bgcolor: 'rgba(84, 214, 44, 0.16)' } }}>
                            Undo
                        </Button>
                        <Iconify onClick={() => closeSnackbar(key)} icon={'radix-icons:cross-2'} height={15} width={15} sx={{ margin: '0px 8px', cursor: 'pointer' }} />
                    </>
            });
            return;
        }
        if (data.message === 'Task not completed !') {
            setMarkComplete(false);
            enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
            });
            return;
        }
        enqueueSnackbar(data.message || '', {
            variant: data.success ? 'success' : 'error',
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });
    };

    const undoReminder = () => {
        setMarkComplete(false);
        dispatch(updateReminder({ is_completed: false }, reminderDataId.current, practiceId, handleReminder, 'markComplete'));
        closeSnackbar();
    };

    const handleDeleteReminder = (data) => { setDeleteData(data); setDeleteConfirm(true); };

    const deleteConfirmAPI = () => {
        dispatch(deleteReminderData(practiceId, deleteData?.id, handleSuccess, handleReminder));
        sidebarCloser();
    };

    const { toggle: openContacts, onOpen: onOpenContacts, onClose: onCloseContacts } = useToggle();
    const { toggle: leadDetailModal, onOpen: onLeadDetail, onClose: onCloseLeadDetail } = useToggle();
    const { toggle: openRecordAttend, onOpen: onOpenRecordAttend, onClose: onCloseRecordAttend } = useRecordAttendToggle();
    const { toggle: openUnRecordAttend, onOpen: onOpenUnRecordAttend, onClose: onCloseUnRecordAttend } = useUnRecordAttendToggle();
    const { toggle: openArchiveLead, onOpen: onOpenArchiveLead, onClose: onCloseArchiveLead } = useArchivedToggle();
    const { toggle: openReminder, onOpen: onOpenReminder, onClose: onCloseReminder } = useReminderToggle();
    const { toggle: openAssignTask, onClose: onCloseAssignTask } = useAssignTaskToggle();
    const { toggle: openConsultationAttend, onOpen: onOpenConsultationAttend, onClose: onCloseConsultationAttend } = useConsultationAttendToggle();
    const { toggle: openAppointmentAssignTask, onOpen: onOpenAppointmentAssignTask, onClose: onCloseAppointmentAssignTask } = useAssignTaskToggle();

    const openAppointmentAssignTaskFuc = (value, assigneesVal, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAppointmentAssignTask();
        setReminderID(value?.lead_id);
        setAssignees(assigneesVal);
    };

    const editDetailHandler = () => { onLeadDetail(); };
    const closeEditDetails = () => { onCloseLeadDetail(); };

    const handlePopup = (id, reminderItem, status) => {
        localStorageRemoveItem('localTreatmentData');
        if (status === 'NEW') dispatch(getActivities(practiceId, id, 10, 0));
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateFollowUpLead('contact'));
        leadDataHandler(reminderItem);
        setLead(id);
        dispatch(followUpSlice(id, practiceId));
        setTimeout(() => {
            const htmlElement = document.querySelector('body');
            htmlElement.classList.add('overflow-hidden');
            onOpenContacts();
        }, 800);
    };

    const handleAttendedPopup = async (id, reminderItem) => {
        localStorageRemoveItem('localTreatmentData');
        dispatch(updateFollowUpLead('consultation'));
        leadDataHandler(reminderItem);
        setLead(id);
        dispatch(followUpSlice(id, practiceId));
        const taskData = reminderList?.find((el) => el.id === reminderItem);
        dispatch(setCurrentTreatmentDataGlobal({
            lead_id: taskData?.lead?.id || id || '',
            first_name: taskData?.lead?.first_name || '',
            last_name: taskData?.lead?.last_name || '',
            treatmentData: taskData?.lead_treatment
        }));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, id));
            onOpenConsultationAttend(id);
        }, 800);
    };

    const leadDataHandler = (id) => {
        reminderDataId.current = id;
        const data = reminderList?.filter((el) => el.id === id);
        setRowLead({
            lead_id: data[0]?.lead_treatment?.lead || '',
            treatment_id: data[0]?.lead_treatment?.id || '',
            price: data[0]?.lead_treatment?.price || '',
            first_name: data[0]?.lead?.first_name || '',
            last_name: data[0]?.lead?.last_name || '',
            status: data[0]?.lead_treatment?.status || '',
            treatment_name: data[0]?.lead_treatment?.treatment || '',
            created_at_human: data[0]?.lead?.created_at_human,
            lead_treatments__lead_contacted_counts__count: data[0]?.lead_treatment?.lead_contacted_counts?.find(item => item.status === data[0]?.lead_treatment?.status)?.count || 0,
            clinCheckData: data[0]?.lead_treatment?.leadtreatment_clincheck,
            leadTreatmentSpecification: data[0]?.lead_treatment?.leadtreatment_specification,
            treatmentData: data[0]
        });
    };

    const [rowLead, setRowLead] = useState({
        lead_id: '', treatment_id: '', price: '', first_name: '', last_name: '', status: '', treatment_name: '', created_at_human: '', lead_treatments__lead_contacted_counts__count: 0
    });

    useEffect(() => { if (rowLead) dispatch(tableLead(rowLead)); }, [rowLead]);

    const switchHandler = (value) => {
        dispatch(taskUnassignedUser(false));
        dispatch(setAssigned(value));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, currentTab === 'All' ? '' : currentTab, leadId.id, value ? userID : '', '', '', '', additionalTabState, isTasksCompleted, false, '', false));
        onChangeRowsPerPage({ target: { value: 10 } });
        dispatch(updateLeadTaskCounter([]));
        reloadTaskCounter({ userId: value ? userID : '', id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: false });
    };

    const switchCompletedTasksHandler = (value) => {
        const assigneesStr = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        dispatch(taskCompletedUser(value));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, currentTab === 'All' ? '' : currentTab, leadId.id, assigneesStr, '', '', '', additionalTabState, value, false, '', unassignedUser));
        onChangeRowsPerPage({ target: { value: 10 } });
        dispatch(updateLeadTaskCounter([]));
        reloadTaskCounter({ userId: assigneesStr, id: leadId.id, additionalFilter: additionalTabState, CompletedTask: value, unassignedUser });
    };

    const switchUnassignedTasksHandler = (value) => {
        dispatch(setAssigned(false));
        dispatch(taskUnassignedUser(value));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, currentTab === 'All' ? '' : currentTab, leadId.id, '', '', '', '', additionalTabState, isTasksCompleted, false, '', value));
        onChangeRowsPerPage({ target: { value: 10 } });
        dispatch(updateLeadTaskCounter([]));
        reloadTaskCounter({ userId: '', id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: value });
    };

    const switchHandleAllTasks = () => {
        dispatch(setAssigned(false));
        dispatch(taskUnassignedUser(false));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, currentTab === 'All' ? '' : currentTab, leadId.id, '', '', '', '', additionalTabState, isTasksCompleted, false, '', false));
        onChangeRowsPerPage({ target: { value: 10 } });
        dispatch(updateLeadTaskCounter([]));
        reloadTaskCounter({ userId: '', id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser: false });
    };

    const allPopupCloseHandler = (value) => {
        dispatch(setLoader(false));
        const assigneesStr = assigneeDataFilter.length ? assigneeDataFilter.toString() : assignedUser ? userID : '';
        switch (value) {
            case 'Reminder':
                onCloseReminder();
                onChangeTab('', 'All');
                dispatch(setAssigned(false));
                dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadId.id, assigneesStr, '', 'leadNotes', 'counter', additionalTabState, isTasksCompleted, '', '', ''));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', leadDetail?.lead_treatments[0]?.status, leadId.id, assigneesStr, additionalTabState));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', 'TODO', leadId.id, assigneesStr, additionalTabState));
                dispatch(leadTaskListCounter(practiceId, 'LeadDetail', '', leadId.id, assigneesStr, additionalTabState));
                setLeadData({});
                return;
            case 'Attended':
                onCloseRecordAttend();
                setAnchorElAssign(null);
                break;
            case 'Dialog':
                dispatch(clearLead());
                dispatch(setCurrentTreatmentDataGlobal(null));
                dispatch(updateSteps(null));
                onCloseContacts();
                setOpenSidebar(false);
                break;
            case 'UnAttended':
                onCloseUnRecordAttend();
                break;
            case 'Consultation':
                onCloseConsultationAttend();
                setAnchorElAssign(null);
                break;
            case 'Assigned':
                onCloseAssignTask();
                setAnchorElAssign(null);
                break;
            default:
                break;
        }
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', rowsPerPage, rowsPerPage * page, currentTab === 'All' ? '' : currentTab, leadId.id, assigneesStr, '', '', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
    };

    const getReminderBtn = (status, id, reminderItem, leadTreatmentVal, archive) => {
        if (archive) {
            return <Button variant="contained" color='primary' disabled sx={{ mb: '4px' }}>Archived</Button>;
        }
        if (!leadTreatmentVal) return '';
        if (status === 'CLOSED') return '';
        if (status === 'TREATMENT_STARTED') {
            return <Button variant="contained" color='primary' onClick={() => viewDetailBtn(id, status, reminderItem)} sx={taskButton}>Complete treatment</Button>;
        }
        if (status === 'CONSULTATION_ATTENDED') {
            return <Button variant="contained" color='primary' startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />} onClick={() => handleAttendedPopup(id, reminderItem)} sx={taskButton}>Follow Up</Button>;
        }
        if (status === 'FAILED_TO_ATTEND_CONSULTATION') {
            return <Button variant="contained" color='primary' startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />} onClick={() => handleAttendFailedClick(id, reminderItem)} sx={taskButton}>Follow Up</Button>;
        }
        return <Button variant="contained" color='primary' startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />} onClick={() => handlePopup(id, reminderItem, status)} sx={taskButton}>Follow Up</Button>;
    };

    const handleFollowUp = (status, id, reminderItem, leadTreatmentVal, archive) => {
        if (archive) return;
        if (!leadTreatmentVal) return;
        if (status === 'CLOSED' || status === 'TREATMENT_STARTED') { viewDetailBtn(id, status, reminderItem); return; }
        if (status === 'CONSULTATION_ATTENDED') { handleAttendedPopup(id, reminderItem); return; }
        if (status === 'FAILED_TO_ATTEND_CONSULTATION') { handleAttendFailedClick(id, reminderItem); return; }
        handlePopup(id, reminderItem, status);
    };

    const viewDetailBtn = (id, status, reminderItem) => {
        localStorageRemoveItem('localTreatmentData');
        if (status === 'CLOSED') { navigate(`/dashboard/practice/${practiceId}/lead-detail/${id}`); return; }
        if (status === 'TREATMENT_STARTED') { setConfirmation(true); reminderDataId.current = reminderItem; }
    };

    const completeTreatmentAPI = () => {
        const reminderId = reminderList.filter((el) => el.id === reminderDataId.current);
        const data = {
            treatment: reminderId[0]?.lead_treatment?.treatment || leadData?.lead_treatment?.treatment || '',
            custom_price: reminderId[0]?.lead_treatment?.price || leadData?.lead_treatment?.price || ''
        };
        dispatch(setLoader(true));
        dispatch(CompleteTreatment(data, reminderId[0]?.lead_treatment?.lead || leadData?.lead_treatment?.lead, reminderId[0]?.lead_treatment?.id || leadData?.lead_treatment?.id, practiceId, handleClose));
    };

    const markCompleteBtn = (value, markTasks) => {
        reminderDataId.current = value;
        setMarkComplete(value);
        dispatch(updateReminder({ is_completed: !markTasks }, value, practiceId, handleReminder, 'markComplete', handleSuccess, markTasks && 'isCompleted'));
    };

    const tabCounter = (data) => taskLeadCounter?.filter(value => value.filter === data ? value.count : 0)[0]?.count;

    const sidebarHandler = (data) => { setLeadData(data); setOpenSidebar(true); };
    const sidebarCloser = () => { setDeleteConfirm(false); setOpenSidebar(false); setDeleteData(null); setLeadData(null); };

    const handleArchivedClose = () => { onCloseArchiveLead(); dispatch(updateFollowUpLead('contact')); };

    const handleDropdownChange = (event) => {
        const values = event.target.value;
        setSelectedAssigneeFilter([]);
        setValue('multiSelectAssignee', []);
        if (values === 'My tasks') { setSelectedValue('My tasks'); switchHandler(true); }
        else if (values === 'Unassigned tasks') { setSelectedValue('Unassigned tasks'); switchUnassignedTasksHandler(true); }
        else { setSelectedValue('All'); switchHandleAllTasks(); }
    };

    const onClickAwayEvent = () => {
        if (document.querySelector('.MuiModal-root')) return;
        onCloseAssignTask(); setAnchorElAssign(null); dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        if (document.querySelector('.MuiModal-root')) return;
        onCloseAppointmentAssignTask(); setAnchorElAssign(null); dispatch(clearPracticeUserData());
    };

    const handleAssigneeFilter = (e, value) => {
        if (value) {
            const ids = [];
            value.forEach((data) => ids.push(data.id));
            setValue('multiSelectAssignee', ids);
            setSelectedAssigneeFilter(value);
            setSelectedValue('All');
            dispatch(setAssigned(false));
            dispatch(taskUnassignedUser(false));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, currentTab === 'All' ? '' : currentTab, leadId.id, ids?.toString() || '', '', '', '', additionalTabState, isTasksCompleted, false, '', unassignedUser));
            onChangeRowsPerPage({ target: { value: 10 } });
            dispatch(updateLeadTaskCounter([]));
            reloadTaskCounter({ userId: ids?.toString(), id: leadId.id, additionalFilter: additionalTabState, CompletedTask: isTasksCompleted, unassignedUser });
        }
    };

    // --- Rendering helpers ---

    const getChannelIcon = (method) => {
        const map = { CALL: 'fluent:call-12-regular', EMAIL: 'mdi:email-outline', WHATSAPP: 'mdi:whatsapp', SMS: 'mdi:message-text-outline' };
        return map[method] || '';
    };

    const getContactCount = (data) => {
        const cnt = data?.lead_treatment?.lead_contacted_counts?.[0]?.count;
        return typeof cnt === 'number' ? cnt : null;
    };

    const getContactCountColor = (count) => {
        if (count === null || count === undefined || count === 0) return null;
        if (count === 1) return '#919EAB';
        if (count === 2) return '#FFAB00';
        return '#FF5630';
    };

    const getContactCountHint = (count) => {
        if (count === null || count === undefined || count === 0) return null;
        if (count === 1) return '1st follow-up';
        if (count === 2) return '2nd follow-up — try a different channel';
        return `${count}${count === 3 ? 'rd' : 'th'} follow-up — consider calling or escalating`;
    };

    const renderTaskCard = (data) => {
        const { icon, iconColor } = getIconAndColor(data.priority);
        const priorityColor = getPriorityColor(data.priority);
        const isOverdue = data.datetime && new Date(data.datetime) < new Date() && !data.is_completed;
        const initials = `${(data?.lead?.first_name || '')[0] || ''}${(data?.lead?.last_name || '')[0] || ''}`.toUpperCase();
        const channelIcon = getChannelIcon(data?.method);
        const journeyDot = (data.method === 'PAYMENT' && !data.lead_treatment) ? '#FFAB00' : getJourneyDot(data?.lead_treatment?.status);
        const journeyLabel = (data.method === 'PAYMENT' && !data.lead_treatment) ? 'Payment pending' : getJourneyLabel(data?.lead_treatment?.status);
        const contactCount = getContactCount(data);
        const contactColor = getContactCountColor(contactCount);
        const contactHint = getContactCountHint(contactCount);

        return (
            <Paper
                key={data.id}
                sx={{
                    ...taskListCardStyle(data?.lead?.is_archived, data?.lead?.is_archive_pending, priorityColor, isOverdue),
                    borderLeft: contactColor ? `4px solid ${contactColor}` : 'none',
                    border: isOverdue ? `1px solid ${alpha(theme.palette.error.main, 0.2)}` : '1px solid #f0f0f0',
                    ...(contactColor && !isOverdue && { borderLeft: `4px solid ${contactColor}` }),
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', p: '14px 16px', cursor: 'pointer' }} onClick={() => sidebarHandler(data)}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                            <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: alpha(theme.palette.primary.main, 0.08), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 600, color: 'primary.main', flexShrink: 0 }}>
                                {initials}
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '18px' }} noWrap>
                                    {capitalizeFirstLetter(data?.lead?.first_name || '')} {capitalizeFirstLetter(data?.lead?.last_name || '')}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: '1px' }}>
                                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: journeyDot, flexShrink: 0 }} />
                                    <Typography sx={{ fontSize: '11px', color: 'text.disabled', lineHeight: '14px' }} noWrap>{journeyLabel}</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                            {data.priority && data.priority !== 'NORMAL' && <Iconify width={14} height={14} icon={icon} sx={{ color: iconColor }} />}
                            {channelIcon && <Iconify width={14} height={14} icon={channelIcon} sx={{ color: 'text.disabled' }} />}
                            <Tooltip title={data.id === markComplete || tasksCompletedUser ? 'Mark as incomplete' : 'Mark as complete'} placement='top'>
                                <Box
                                    onClick={(e) => { e.stopPropagation(); markCompleteBtn(data.id, tasksCompletedUser); }}
                                    sx={{
                                        width: 20, height: 20, minWidth: 20,
                                        borderRadius: '50%', cursor: 'pointer',
                                        border: (data.id === markComplete || tasksCompletedUser) ? 'none' : '2px solid #d0d0d0',
                                        bgcolor: (data.id === markComplete || tasksCompletedUser) ? '#00A76F' : 'transparent',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {(data.id === markComplete || tasksCompletedUser) && <Iconify icon="mdi:check" width={14} sx={{ color: '#fff' }} />}
                                </Box>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary', mb: contactHint ? 0.5 : 1.5, lineHeight: '18px' }} noWrap>
                        {data.title ? capitalizeFirstLetter(data.title) : (data?.lead_treatment?.treatment || (data.method === 'PAYMENT' ? 'Dentally payment pending' : ''))}
                    </Typography>
                    {contactHint && (
                        <Typography sx={{
                            fontSize: '11px',
                            color: contactColor,
                            fontWeight: 500,
                            mb: 1.5,
                            lineHeight: '14px',
                        }} noWrap>
                            {contactHint}
                        </Typography>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
                        <Typography sx={{ fontSize: '11px', color: 'text.disabled' }}>{data.datetime_human || ''}</Typography>
                        {isOverdue && (
                            <Typography sx={{ fontSize: '11px', fontWeight: 500, color: 'error.main', bgcolor: alpha(theme.palette.error.main, 0.08), px: 1, py: 0.25, borderRadius: '4px' }}>Overdue</Typography>
                        )}
                    </Box>
                </Box>
            </Paper>
        );
    };

    return (
        <>
            <Card sx={taskCard('LeadDetail')}>
                {/* Header: filters + new task button */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, px: 3, py: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, flex: 1 }}>
                        <FormControl variant="outlined" size="small" sx={{ minWidth: 160 }}>
                            <InputLabel>Status</InputLabel>
                            <Select value={currentTab} onChange={(event) => handleFilterTask(event, event.target.value)} label="Status">
                                {TASK_TAB_HEAD.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Iconify icon={item?.icon} width={16} height={16} sx={{ mr: 1, color: 'text.disabled' }} />
                                                {item?.label}
                                            </Box>
                                            <Label sx={{ ml: 1, minWidth: '20px', color: isLight ? 'common.grey' : 'common.white', background: isLight ? `${common.boxShadowColor}` : 'rgba(145, 158, 171, 0.16)' }}>
                                                {tabCounter(item.value) || 0}
                                            </Label>
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" sx={{ minWidth: 140 }}>
                            <InputLabel>Assignees</InputLabel>
                            <Select value={selectedValue} onChange={handleDropdownChange} label="Assignees">
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="My tasks">My tasks</MenuItem>
                                <MenuItem value="Unassigned tasks">Unassigned tasks</MenuItem>
                            </Select>
                        </FormControl>
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                            <MultiAssigneesDropdown
                                name={'multiSelectAssignee'}
                                label='Assignee users'
                                sx={{ ...treatmentBoxStyle, maxWidth: "400px" }}
                                onChange={handleAssigneeFilter}
                                value={selectedAssigneeFilter}
                                type={'LeadDetail'}
                            />
                        </FormProvider>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="body2" sx={{ fontSize: '12px', color: 'text.disabled', whiteSpace: 'nowrap' }}>Completed</Typography>
                            <Switch checked={Boolean(tasksCompletedUser)} onClick={(e) => switchCompletedTasksHandler(e.target.checked)} color="primary" size="small" />
                        </Box>
                    </Box>
                    {addTaskHide && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleReminderPopup('addTask')}
                            startIcon={<Iconify icon={'ic:baseline-plus'} width={18} height={18} />}
                            sx={{ bgcolor: '#00A76F', '&:hover': { bgcolor: '#007B55' }, whiteSpace: 'nowrap', height: '36px', textTransform: 'none', fontWeight: 600, fontSize: '13px' }}
                        >
                            New Task
                        </Button>
                    )}
                </Box>

                {/* Flat task list */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, px: 3, pb: 3 }}>
                    {reminderList.map((data) => renderTaskCard(data))}
                </Box>

                {/* Empty state */}
                {(reminderList.length === 0 && reminder?.count !== undefined) && <Box sx={{ px: 3, pb: 2 }}><NotFound /></Box>}

                {/* Pagination */}
                <Box sx={{ px: 2 }}>
                    {reminder?.count > 10 &&
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            rowsPerPage={rowsPerPage}
                            count={reminder?.count || 0}
                            page={page}
                            onPageChange={(event, newPage) => handleChangePage(event, newPage)}
                            onRowsPerPageChange={(event) => handleChangePerPage(event)}
                            nextIconButtonProps={page === Math.ceil(reminder?.count / rowsPerPage) ? { disabled: true } : undefined}
                        />
                    }
                </Box>

                {/* Popper for attended/failed buttons */}
                <Popper sx={{ zIndex: 1, margin: '0px 20px !important' }} open={open} anchorEl={anchorEl} role={undefined} transition placement={isDesktop ? 'left-start' : 'right-start'}>
                    {({ TransitionProps }) => (
                        <Grow {...TransitionProps}>
                            <Paper>
                                <ClickAwayListener onClickAway={buttonHandleClose}>
                                    <MenuList id="split-button-menu" autoFocusItem sx={plusButton}>
                                        <MenuItem key="Attended" onClick={() => handleAttendClick()} sx={plusMenu}>
                                            <Iconify style={plusMenuIcon} width={20} height={20} icon={'akar-icons:check'} /> Attended
                                        </MenuItem>
                                        <MenuItem key="Failed to attend" onClick={() => handleAttendFailedClick()} sx={plusMenu}>
                                            <Iconify style={plusMenuIcon} width={20} height={20} icon={'ci:close-big'} /> Failed to attend
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>

                {/* Add/Edit reminder popup */}
                <AddReminderPopup
                    open={openReminder}
                    onClose={() => allPopupCloseHandler('Reminder')}
                    leadDetail={leadDetail}
                    leadData={leadData}
                    type={addPopupType}
                    page={'LeadDetail'}
                    handleLoading={handleLoading}
                />

                {/* Assign task popup */}
                {openAssignTask && (
                    <ClickAwayListener onClickAway={onClickAwayEvent}>
                        <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement="bottom" sx={{ zIndex: '999999' }}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ borderRadius: 2 }}>
                                        <AssignTaskPopup
                                            open={openAssignTask}
                                            onClose={() => allPopupCloseHandler('Assigned')}
                                            leadDetail={leadDetail}
                                            reminder={reminderData}
                                            assignees={assigneeData?.filter((el) => el?.user?.first_name && !el?.user?.is_superuser)?.map((ele) => ele.id)}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}

                {/* Attended popup */}
                <OpenAttendedPopup
                    open={openRecordAttend}
                    isOverview
                    headerButtons
                    onClose={() => allPopupCloseHandler('Attended')}
                    user={rowLead}
                    type={'recordAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    OpenAssignTask={openAppointmentAssignTaskFuc}
                    editDetailHandler={editDetailHandler}
                />

                {/* Contact popup */}
                {openContacts && <OpenContactLeadPopup
                    open={openContacts}
                    headerButtons
                    onClose={() => allPopupCloseHandler('Dialog')}
                    openArchivePopup={onOpenArchiveLead}
                    user={rowLead}
                    steps={leadStep}
                    BookingAttendance={BookingAttendance}
                    type={'followup'}
                    validStep={validStep}
                    updateStep={() => setValidStep(!validStep)}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    ContactedCount={rowLead?.lead_treatments__lead_contacted_counts__count}
                />}

                {/* Unattended popup */}
                <OpenUnAttendedPopup
                    open={openUnRecordAttend}
                    headerButtons
                    onClose={() => allPopupCloseHandler('UnAttended')}
                    user={rowLead}
                    type={'recordUnAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                />

                {/* Archive popup */}
                {openArchiveLead && <ArchivedLeadPopUp
                    open={openArchiveLead}
                    headerButtons
                    onClose={handleArchivedClose}
                    user={leadData}
                    type={'archiveLead'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                />}

                {/* Consultation popup */}
                <OpenConsultationPopup
                    open={openConsultationAttend}
                    headerButtons
                    onClose={() => allPopupCloseHandler('Consultation')}
                    user={rowLead}
                    type={'consultationAttended'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    OpenAssignTask={openAppointmentAssignTaskFuc}
                    editDetailHandler={editDetailHandler}
                    selectedTreatmentData={currentTreatmentDataGlobal}
                />

                {/* Task sidebar */}
                {openSidebar && <ReusableSidebar
                    type='Task'
                    getReminderBtn={getReminderBtn}
                    handleFollowUp={handleFollowUp}
                    data={leadData}
                    open={openSidebar}
                    reminderDataId={reminderDataId}
                    handleAttendClick={handleAttendClick}
                    handleAttendFailedClick={handleAttendFailedClick}
                    onClose={sidebarCloser}
                    handleReminderPopup={handleReminderPopup}
                    deleteTask={handleDeleteReminder}
                    setReloadCounters={setReloadCounters}
                    parentType='LeadDetail'
                    onTaskUpdate={onTaskUpdate}
                />}

                {/* Appointment assign task popup */}
                {openAppointmentAssignTask && (
                    <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                        <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement="bottom" sx={{ zIndex: '999999' }}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ borderRadius: 2 }}>
                                        <AppointmentAssignTaskPopup
                                            open={openAppointmentAssignTask}
                                            onClose={() => { onCloseAppointmentAssignTask(); setAnchorElAssign(null); }}
                                            user={leadData}
                                            leadId={leadData || reminderData}
                                            type={'leadAssign'}
                                            leadDetail={leadDetail}
                                            assignees={assignees}
                                            selectedTreatmentData={currentTreatmentDataGlobal}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}

                {/* Edit personal details */}
                {leadDetailModal &&
                    <EditPersonalDetailsPopup
                        open={leadDetailModal}
                        handleClose={closeEditDetails}
                        selectedRow={leadData}
                        type={'editLead'}
                        inputRef={personalDetailPopupRef}
                        title='Edit Details'
                        headerButtons
                    />
                }

                {/* Complete treatment dialog */}
                <Dialog open={confirmation} onClose={() => setConfirmation(false)}>
                    <DialogTitle sx={{ padding: '40px 40px 0px', textAlign: 'center' }}>
                        Are you sure you want to complete the treatment ?
                    </DialogTitle>
                    <DialogActions sx={{ padding: '40px !important', justifyContent: 'center' }}>
                        <Button sx={completeTreatmentCancel} onClick={() => setConfirmation(false)}>Cancel</Button>
                        <LoadingButton
                            type='submit' variant='contained' loading={isLoader} loadingPosition='start'
                            onClick={() => completeTreatmentAPI()} sx={{ ...yesBtnStyleForLoader(isLoader) }} disabled={isLoader}
                        >
                            Complete treatment
                        </LoadingButton>
                    </DialogActions>
                </Dialog>

                {/* Delete confirmation dialog */}
                <Dialog open={deleteConfirm} onClose={() => setDeleteConfirm(false)}>
                    <DialogTitle sx={{ padding: '40px 40px 0px', textAlign: 'center' }}>
                        Are you sure you want to delete ?
                    </DialogTitle>
                    <DialogActions sx={{ padding: '40px !important', justifyContent: 'center' }}>
                        <Button sx={completeTreatmentCancel} onClick={() => setDeleteConfirm(false)}>Cancel</Button>
                        <Button type="submit" sx={completeTreatmentConfirm} onClick={() => deleteConfirmAPI()}>Delete task</Button>
                    </DialogActions>
                </Dialog>
            </Card>
        </>
    );
};

LeadDetailTasksV1.propTypes = {
    reminder: PropTypes.object,
    leadDetail: PropTypes.object,
    reloadTaskCounter: PropTypes.func,
    handleLoading: PropTypes.func,
};

// §9 MUST FE — top-level gate. For `tasks-v2` view/manage practices we mount
// a thin V2 wrapper around <LeadTaskList>; otherwise we mount the existing V1
// implementation untouched. Splitting at the component boundary (rather than an
// in-body early return) keeps React rules-of-hooks happy because each render
// path only mounts one of the two component trees.
const LeadDetailTasksV2 = ({ leadDetail }) => {
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const leadId = leadDetail?.lead_id || leadDetail?.id || null;
    if (!practiceId || !leadId) return null;
    return (
        <Box sx={{ pt: 3 }}>
            <Card sx={{ boxShadow: 'none', p: '16px' }}>
                <TaskErrorBoundary>
                    <LeadTaskList leadId={leadId} practiceId={practiceId} />
                </TaskErrorBoundary>
            </Card>
        </Box>
    );
};

LeadDetailTasksV2.propTypes = {
    leadDetail: PropTypes.object,
};

const LeadDetailTasks = (props) => {
    const { canView: hasTasksV2 } = useFeaturePermission('tasks-v2');
    return hasTasksV2 ? <LeadDetailTasksV2 {...props} /> : <LeadDetailTasksV1 {...props} />;
};

LeadDetailTasks.propTypes = {
    reminder: PropTypes.array,
    leadDetail: PropTypes.object,
    reloadTaskCounter: PropTypes.bool,
    handleLoading: PropTypes.func,
};

export default LeadDetailTasks;
